var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gerenshenhe"},[_c('div',{staticClass:"grshenhe-time"},[_c('el-timeline',{attrs:{"reverse":_vm.reverse}},_vm._l((_vm.activities),function(activity,index){return _c('el-timeline-item',{key:index,attrs:{"color":activity.color,"timestamp":activity.timestamp}},[_vm._v("\n        "+_vm._s(activity.content)+"\n      ")])}),1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56883a13","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GeRenshenhe.vue
// module id = null
// module chunks = 